import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { SavingStatus } from 'src/utils/enums';
import { useStores } from 'src/components/store';
import ThreeDotLoadingAnimation from './three-dot-loading-animation/three-dot-animation';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import './saving-status-indication.scss';

export const SavingStatusIndication: React.FC<{ versionDescription?: string }> = observer(({ versionDescription }) => {
    const { fwVersionStore } = useStores();

    const savingStatus = useMemo(() => {
        if (versionDescription === 'Applied') return <span className="saved-icon" data-testid={'create-saved-icon'}>
            <CustomIcon type={IconType.CreateSavedStatus} />
        </span>;
        if (versionDescription === 'Pending') return <span className="pending-icon" data-testid={'pending-icon'}>
            <CustomIcon type={IconType.STATUS_PENDING} />
        </span>;

        switch (fwVersionStore.savingStatus) {
            case SavingStatus.Saving: case SavingStatus.Applying:
                return <span data-testid={'create-saving-icon'}>
                    <ThreeDotLoadingAnimation />
                </span>;
            case SavingStatus.Saved:
                return <span data-testid={'create-saved-icon'}>
                    <CustomIcon type={IconType.CreateSavedStatus} />
                </span>;
            default:
                return <></>;
        }
    }, [fwVersionStore.savingStatus, versionDescription]);

    return <div className={`saving-status-indication`} data-testid="saving-status-indication">{savingStatus}</div>;
});